<div class="timer">
  Remaining time
  <div>
    {{ hours | number: '2.0' }}:{{ minutes | number: '2.0' }}:{{ seconds | number: '2.0' }}
  </div>
</div>
